import { render, staticRenderFns } from "./orderOrderDetail.vue?vue&type=template&id=3886089c&scoped=true"
import script from "./orderOrderDetail.vue?vue&type=script&lang=js"
export * from "./orderOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderOrderDetail.vue?vue&type=style&index=0&id=3886089c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3886089c",
  null
  
)

export default component.exports